export const appHead = {"link":[{"rel":"apple-touch-icon","sizes":"180x180","href":"/apple-touch-icon.png?v=1","type":"image/png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicon-32x32.png?v=1"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/favicon-16x16.png?v=1"},{"rel":"mask-icon","href":"/safari-pinned-tab.svg?v=1","color":"#8d6558"},{"rel":"shortcut icon","href":"/favicon.ico?v=1","type":"image/vnd.microsoft.icon","sizes":"16x16 32x32 48x48"},{"rel":"manifest","href":"/manifest.json"}],"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=10, user-scalable=1"},{"property":"og:type","content":"website"}],"style":[],"script":[{"tagPriority":"critical","innerHTML":"window.__earlyErrors={errors:[],on:function(e){window.__earlyErrors.errors.push(e.error||e.reason||e.message)}};addEventListener(\"error\",__earlyErrors.on);addEventListener(\"unhandledrejection\",__earlyErrors.on);"}],"noscript":[{"innerHTML":"This website requires JavaScript."}],"htmlAttrs":{"lang":"en"}}

export const appPageTransition = {"name":"fade","mode":"out-in"}

export const appLayoutTransition = {"name":"fade","mode":"out-in"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appViewTransition = {"enabled":true}

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const componentIslandsActive = false

export const payloadExtraction = true

export const prefetchPreloadTags = false

export const cookieStore = true

export const appManifest = true

export const serverPathFallback = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const useStateDefaults = {"resetOnClear":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = true

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const stripNeverHydratedData = false

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false

export const routeTypedFetch = false

export const asyncCallHook = true

export const clientNodePlaceholder = false

export const tracingChannelNuxt = false

export const runtimeCompiler = false

export const vapor = false

export const hasPluginDependencies = true

export const hasParallelPlugins = true

export const hasPluginHooks = true

export const hasIslandOptOutPlugins = true